export default "<app-text [prodId]=\"'homepagelogotitle'\"></app-text>\n<app-video></app-video>\n<app-carousel></app-carousel>\n<app-footer></app-footer>"